module.exports = __webpack_public_path__ + "static/media/9.f1f7fd86.jpg";